module.exports = __webpack_public_path__ + "static/media/02.92daf6a6.svg";